module.exports = __webpack_public_path__ + "static/img/JessieCode.ee7bd9ec.jpeg";